import { InputAdornment, TextField } from "@mui/material";
import { Transliteration } from "../common/Transliteration";
import { BsFileCheck } from "react-icons/bs";

export const ProjectDataForm = ({ formData, setFormData, formDataErrors }) => {
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      <TextField
        fullWidth
        placeholder="Назив на проектот (Пр. Основен сообраќаен проект за измена...)"
        autoComplete="off"
        multiline
        rows={3}
        value={formData?.projectTitle || ""}
        onChange={(event) => {
          let value = event.target.value;

          handleChange("projectTitle")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsFileCheck size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.projectTitle ? true : false}
        helperText={formDataErrors.projectTitle || ""}
      />
      <TextField
        fullWidth
        placeholder="Проектантско биро"
        autoComplete="off"
        value={formData?.projectBureauName || ""}
        onChange={(event) => {
          let value = event.target.value;
          handleChange("projectBureauName")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsFileCheck size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.projectBureauName ? true : false}
        helperText={formDataErrors.projectBureauName || ""}
      />
      <TextField
        fullWidth
        placeholder="Технички број"
        autoComplete="off"
        value={formData?.projectTechnicalNumber || ""}
        onChange={(event) => {
          let value = event.target.value;

          handleChange("projectTechnicalNumber")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsFileCheck size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.projectTechnicalNumber ? true : false}
        helperText={formDataErrors.projectTechnicalNumber || ""}
      />
      <TextField
        fullWidth
        placeholder="Локација"
        autoComplete="off"
        value={formData?.locationDescription || ""}
        onChange={(event) => {
          let value = event.target.value;

          handleChange("locationDescription")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsFileCheck size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.locationDescription ? true : false}
        helperText={formDataErrors.locationDescription || ""}
      />
    </div>
  );
};
